import { CloudTagsIcon } from './CloudTagsIcon';

/**
 * author: Andy Martinez
 * id AE3A5033-BA77-4E82-BFD0-4C23275B602F
 * name cloud-tags
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-tags.svg
 * tags
 * - Cloud 
 */
export const CloudXmlIcon = CloudTagsIcon;
export default CloudXmlIcon